import { StyleSheet, View, type DimensionValue } from 'react-native';
import { tokens } from '../../theme/tokens';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type FeaturePageSummaryCardProps = {
  title: string;
  subtitle: string;
  statusLabel: string;
  progressPercent: number;
};

export function FeaturePageSummaryCard({
  title,
  subtitle,
  statusLabel,
  progressPercent,
}: FeaturePageSummaryCardProps) {
  const progressWidth: DimensionValue = `${progressPercent}%`;

  return (
    <AppCard style={styles.card}>
      <View style={styles.titleRow}>
        <View style={styles.titleText}>
          <AppText variant="title" weight="bold">
            {title}
          </AppText>
          <AppText variant="body" tone="muted">
            {subtitle}
          </AppText>
        </View>
        <View style={styles.badge}>
          <AppText variant="caption" weight="semibold" tone="primary">
            {statusLabel}
          </AppText>
        </View>
      </View>

      <View style={styles.progressBlock}>
        <View style={styles.progressMeta}>
          <AppText variant="caption" tone="muted">
            迁移完成度
          </AppText>
          <AppText variant="caption" weight="semibold" tone="primary">
            {progressPercent}%
          </AppText>
        </View>
        <View style={styles.progressTrack}>
          <View style={[styles.progressFill, { width: progressWidth }]} />
        </View>
      </View>
    </AppCard>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.lg,
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: tokens.spacing.md,
  },
  titleText: {
    flex: 1,
    gap: tokens.spacing.sm,
  },
  badge: {
    borderRadius: tokens.radius.full,
    backgroundColor: tokens.colors.surfaceMuted,
    paddingHorizontal: tokens.spacing.md,
    paddingVertical: tokens.spacing.xs,
  },
  progressBlock: {
    gap: tokens.spacing.sm,
  },
  progressMeta: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  progressTrack: {
    height: tokens.layout.progressHeight,
    borderRadius: tokens.radius.full,
    backgroundColor: tokens.colors.surfaceMuted,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    borderRadius: tokens.radius.full,
    backgroundColor: tokens.colors.primary,
  },
});
